import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';
import { Image } from '$components/basic/Image';
import type { DotFlashingProps } from './styled';
import Styled, { DotFlashing, DotsFlashingStyled } from './styled';

interface DeprecatedProps {
  /**
   * @deprecated use render condition instead
   */
  readonly show?: boolean;
  /**
   * @deprecated use size
   */
  readonly height?: number;
  /**
   * @deprecated use size
   */
  readonly width?: number;
}

interface SpinnerTypeProps extends DeprecatedProps {
  readonly type?: 'spinner'; // default type
  readonly size?: number;
}

interface DotFlashingTypeProps extends DotFlashingProps {
  readonly type: 'dot-flashing';
}

export type PreloaderProps = HTMLAttributes<HTMLElement> & (SpinnerTypeProps | DotFlashingTypeProps);

export function Preloader(props: PreloaderProps): JSX.Element | null {
  const { type = 'spinner', className } = props;
  /**
   * With type destructuring TS doesn't narrow down the type in cases.
   * @todo try later with newer TS versions
   */
  // eslint-disable-next-line react/destructuring-assignment
  switch (props.type) {
    case undefined:
    case 'spinner': {
      const { show = false, size = 32, height = 32, width = 32 } = props;
      if (!show) return null;
      return (
        <Styled
          className={classNames(Preloader.displayName, '-spinner', 'fixter-preloader', className)}
          style={{ width: width ?? size, height: height ?? size }}
        >
          <Image
            className="fixter-preloader_icon"
            provider="cloudinary"
            src="/icons/icon_preloader_new_tc1aoz.svg"
            alt="Loading..."
            width="64"
            height="64"
          />
        </Styled>
      );
    }
    case 'dot-flashing': {
      const { mode } = props;
      return (
        <DotsFlashingStyled className={classNames(Preloader.displayName, `-${type}`, `-${mode}`, className)}>
          <DotFlashing mode={mode} />
        </DotsFlashingStyled>
      );
    }
    default:
      return null;
  }
}
Preloader.displayName = 'Preloader';
